export default __webpack_public_path__ + "static/media/codeg.d809c427.png";